<template>
  <font-awesome-icon
    icon="mobile-alt"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons'

library.add(faMobileAlt)

export default {
  name: 'CoozzyMobileAltIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey-dark;
  }
</style>
